export default "__VITE_ASSET__Cd3_N8Nx__"